import React, { useState, useRef } from "react"
import PropTypes from "prop-types"
import { partialStoryShape } from "app/lib/shared_prop_types"

import Spinner from "shared/components/spinner"
import StoryCard from "../get_more_view/story_card"
import spinnerConfig from "../utils/spinner_config"
import ScrollObserver from "shared/components/scroll_observer"

const Blog = ({ page: initialPage, stories: initialStories }) => {
  const [loading, setLoading] = useState(false)
  const [allLoaded, setAllLoaded] = useState(false)
  const [pages, setPages] = useState([initialStories])
  const [page, setPage] = useState(initialPage || 0)
  const scrollRef = useRef(null)

  const fetchNextPage = async () => {
    setLoading(true)
    const response = await fetch(`/blog.json?page=${page + 1}`)
    const nextPage = await response.json()

    setPages([...pages, nextPage])
    setPage(page + 1)
    setLoading(false)
    setAllLoaded(!nextPage.length)
  }

  return (
    <div className="get-more-container">
      <div className="get-more-header">
        <h1>Blog</h1>
      </div>

      {pages.map((page, pageIndex) =>
        page.map(story => (
          <StoryCard
            key={story.id}
            story={story}
            position={pageIndex}
            singleStoryBasePath="explore"
            locationType="blog"
          />
        ))
      )}
      {loading ? (
        <Spinner config={spinnerConfig} />
      ) : (
        !allLoaded && (
          <ScrollObserver
            scrollRef={scrollRef}
            onScrolledIntoView={fetchNextPage}
          >
            <div ref={scrollRef} />
          </ScrollObserver>
        )
      )}
    </div>
  )
}

Blog.propTypes = {
  page: PropTypes.number,
  stories: PropTypes.arrayOf(partialStoryShape),
}

export default Blog
